(function () {
    angular.module('st')
        .controller('CelebrationSearchTermController', [
            '$rootScope', '$scope', '$sce', "$http",
            function ($rootScope, $scope, $sce, $http) {
                var ctrl = this;
                $rootScope.searchTerm = '';

                ctrl.searchCleared = function () {
                    $rootScope.$emit('searchCleared')
                    $rootScope.searchTerm = '';
                }

                ctrl.UpdateTerm = function (term) {
                    $rootScope.searchTerm = term;
                }

                ctrl.GetResultsCount = function () {
                    var length = 0;
                    Object.keys($rootScope.searchResults).forEach(function (key) {
                        var arr = $rootScope.searchResults[key];
                        length += arr.length;
                    })

                    return length;
                }

                ctrl.SearchInitiated = function (facetCtrl) {
                    facetCtrl.notify();
                }
            }]);
})();

